import { Actions, ofActionDispatched } from '@ngxs/store';
import { HandleErrorsGlobalRecord, handleErrors } from '@platform-frontend/util';
import { Observable, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { SignOutOnError } from './session/session.actions';

export const handleErrorsUntilSignedOutOnError =
  <T>(actions$: Actions, errorHandlers: (error: any) => HandleErrorsGlobalRecord) =>
  (obs$: Observable<T>): Observable<T> =>
    obs$.pipe(
      catchError(error => throwAndHandleError<T>(error, errorHandlers(error))),
      takeUntil(actions$.pipe(ofActionDispatched(SignOutOnError)))
    );

const throwAndHandleError = <T>(error: any, errorHandlers: HandleErrorsGlobalRecord): Observable<T> => {
  return throwError(() => error).pipe(handleErrors(errorHandlers));
};
